module.exports = __webpack_public_path__ + "static/media/参数3.6e68b4e4.jpg";